import { useSAsendChatBotNotificationMutation } from '@sim-admin-frontends/data-access';
import {
  getErrorMessage,
  loadingToast,
  TToastType,
  updateToast,
} from '@sim-admin-frontends/ui-shared';
import { useTranslation } from 'react-i18next';

import { TChatBotNotificationsEditValues } from '../../../types/TNotifications';
import ChatBotNotificationsEdit from './ChatBotNotificationsEdit';
import { SHARED_TOAST_ID } from '../view/NotificationsTabs';

export const DEFAULT_CHAT_BOT = 'Charlie';

const ChatBotNotificationsEditContainer = () => {
  const { t } = useTranslation();
  const { mutateAsync: sendNotification } = useSAsendChatBotNotificationMutation();

  const onSubmit = async (values: TChatBotNotificationsEditValues) => {
    loadingToast(t('notifications.toastSubmitting'), {
      toastId: SHARED_TOAST_ID,
    });
    try {
      await sendNotification({
        target: {
          email: values.email,
        },
        notification: {
          type: values.type.value,
          title: values.title,
          subtitle: values.subtitle,
          body: values.body,
          priority: values.priority?.value,
        },
      });
      updateToast(SHARED_TOAST_ID, t('notifications.toastSuccess'), TToastType.SUCCESS);
    } catch (err) {
      updateToast(SHARED_TOAST_ID, getErrorMessage(err), TToastType.ERROR);
    }
  };

  return <ChatBotNotificationsEdit onSubmit={onSubmit} />;
};

export default ChatBotNotificationsEditContainer;
